module.exports = __webpack_public_path__ + "img/text1.bea16bba.png";